module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/img_webinar_03-6d44ca8b741301608d0d073bbbc8917a.png";